import Vue from "vue";
import ElementUI from "element-ui";
import "./assets/styles/element-variables.scss";
import lodash from "lodash";
import VueMarkdown from "vue-markdown";
import hljs from "highlight.js";
import "highlight.js/styles/atom-one-dark.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/styles/reset.scss";
import "./assets/styles/help.scss";

Vue.use(ElementUI);

Vue.component("vue-markdown", VueMarkdown);

Vue.directive("highlight", (el, binding) => {
  const { value } = binding;
  if (!value) {
    return;
  }
  const blocks = el.querySelectorAll("pre code:not([data-highlighted='yes']");
  for (const block of blocks) {
    hljs.highlightElement(block);
  }
});

Vue.prototype.$lodash = lodash;
Vue.prototype.$hljs = hljs;

Vue.config.productionTip = false;

const vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty("--vh", `${vh}px`);

window.addEventListener("resize", () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
});

router.beforeEach(async (to, from, next) => {
  const modelType = parseInt(localStorage.getItem("session/modelType")) || 1;
  store.commit("session/setModelType", modelType);
  await Promise.all([
    store.dispatch("user/handleSpecialOrganizationNameList"),
    store.dispatch("user/handleFetchUserInfo"),
  ]).catch((error) => {
    console.error("beforeEach");
    console.error(error);
  });
  const { signedIn } = store.state.user;
  if (signedIn) {
    await store
      .dispatch("session/handleFetchSessionTitleList")
      .catch((error) => {
        console.error("beforeEach");
        console.error(error);
      });
  }
  const { name: toRouteName } = to;
  const name = "Home";
  if (!signedIn && toRouteName !== name) {
    next({ name });
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
